var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShazam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.165 7.165 0 16 0s16 7.165 16 16-7.165 16-16 16S0 24.835 0 16Zm8.45 4.597c1.31 1.13 3.03 1.695 4.725 1.695 1.772 0 3.544-.616 4.828-1.772.829-.739 1.755-1.732 2.012-2.008a1.86 1.86 0 0 0-.035-2.692 1.83 1.83 0 0 0-2.593.103s-1.002 1.079-1.824 1.823c-1.36 1.233-3.57 1.028-4.7.052-.847-.745-1.335-1.72-1.412-2.774a3.712 3.712 0 0 1 .95-2.696c1.345-1.465 3.788-3.827 4.123-4.15l.038-.037c.719-.719.745-1.875.051-2.62-.693-.718-1.849-.744-2.594-.05-.028.035-.261.263-.615.61-.913.894-2.633 2.578-3.725 3.781-1.336 1.49-2.029 3.416-1.9 5.393.128 2.055 1.078 3.93 2.67 5.342Zm12.146 5.323c.913-.895 2.633-2.579 3.725-3.782 1.361-1.49 2.029-3.39 1.926-5.419-.128-2.055-1.078-3.955-2.697-5.342-2.67-2.311-6.96-2.26-9.579.103-.828.739-1.755 1.732-2.012 2.008l-.068.072a1.86 1.86 0 0 0 .102 2.62 1.83 1.83 0 0 0 2.594-.103s1.002-1.079 1.824-1.823c1.361-1.233 3.57-1.028 4.7-.052.847.745 1.36 1.721 1.412 2.774a3.712 3.712 0 0 1-.95 2.697c-1.344 1.464-3.788 3.826-4.122 4.149l-.038.037a1.885 1.885 0 0 0-.052 2.62c.36.385.848.564 1.336.564.462 0 .924-.18 1.284-.513.028-.036.261-.264.615-.61Z",
    fill: "var(--template-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShazam);
export default __webpack_public_path__ + "static/media/Shazam.a47e4e686552e368ee126a29a61f696c.svg";
export { ForwardRef as ReactComponent };